import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import {
  Container,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  CustomInput,
} from "reactstrap";
import { FaMinusCircle } from "react-icons/fa";
import PageSpinner from "../components/PageSpinner";

import "../styles/login.css";
import logo from "../assets/img/logo.png";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";

class ClubPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: null,
      name: "",
      camps: [],
      campName: "",
      price: "",
      startDate: "",
      endDate: "",
      minDate: "",
      maxDate: "",
      installments: 0,
      processingFee: 5,
      showDatePickerForCampDates: false,
      showTextBoxForInstallment: false,
      showLoader: false,
    };
    this.addCamp = this.addCamp.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.deleteCamp = this.deleteCamp.bind(this);
  }

  componentDidMount() {
    let params = GeneralFunctions.getQueryStringParams(
      this.props.location.search
    );
    let date = new Date().toISOString();
    let maxDate = new Date().setFullYear(new Date().getFullYear() + 1);
    maxDate = new Date(maxDate).toISOString();
    this.setState({
      minDate: date.split("T")[0],
      maxDate: maxDate.split("T")[0],
      code: params.code,
    });
  }

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!this.state.code)
        throw Error(
          "Code required.Use stripe connect to fill the detials first"
        );
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "stripe/connect/user",
        method: "POST",
        data: {
          code: this.state.code,
          name: this.state.name,
          camps: this.state.camps,
        },
      });
      if (response && response.success) {
        window.location.href = response.url;
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({ showLoader: false });
    }
  };

  addCamp = () => {
    let startDate;
    let endDate;
    if (this.state.showDatePickerForCampDates) {
      startDate = this.state.startDate;
      endDate = this.state.endDate;
    } else {
      startDate = new Date().toISOString().split("T")[0];
      endDate = new Date().setFullYear(new Date().getFullYear() + 1);
      endDate = new Date(endDate).toISOString().split("T")[0];
    }
    if (this.state.campName && this.state.price) {
      this.state.camps.push({
        name: this.state.campName,
        price: this.state.price,
        startingAt: startDate,
        endingAt: endDate,
        installments: this.state.installments,
        processingFee: this.state.processingFee,
      });
      this.setState({
        campName: "",
        price: "",
        startDate: "",
        endDate: "",
        installments: 0,
        showTextBoxForInstallment: false,
        showDatePickerForCampDates: false,
      });
    }
  };

  deleteCamp = (index) => {
    this.state.camps.splice(index, 1);
    this.setState({
      campName: "",
      price: "",
      startDate: "",
      endDate: "",
    });
  };

  toggle = () => {
    this.setState({
      showDatePickerForCampDates: true,
    });
  };

  render() {
    let disabled = false;
    return (
      <div style={{ backgroundColor: "#12405E", height: "100%" }}>
        <Container style={{ backgroundColor: "#12405E", maxWidth: "100%" }}>
          <PageSpinner showLoader={this.state.showLoader} />
          <div className="login-form" style={{ backgroundColor: "white" }}>
            <div className="imgLogoDiv">
              <img alt="" src={logo} className="imgLogo"></img>
            </div>
            <Form
              className="form"
              onSubmit={this.onSubmit}
              style={{ marginTop: "-30px" }}
            >
              <Col style={{ textAlign: "center" }}>
                <h2>Zocial</h2>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Club Name</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    value={this.state.name}
                    onChange={(event) => {
                      this.setState({
                        name: event.target.value,
                      });
                    }}
                    placeholder="Enter the name"
                    required
                  />
                </FormGroup>
              </Col>
              <Col>
                <Label>Add Camps :</Label>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Name</Label>
                  <Input
                    id="campName"
                    name="campName"
                    type="text"
                    value={this.state.campName}
                    onChange={(event) => {
                      this.setState({
                        campName: event.target.value,
                      });
                    }}
                    placeholder="Enter the name"
                    required={false}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Price</Label>
                  <Input
                    id="name"
                    name="name"
                    type="number"
                    value={this.state.price}
                    onChange={(event) => {
                      this.setState({
                        price: event.target.value,
                      });
                    }}
                    placeholder="Enter the price"
                    required={false}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="exampleCheckbox">Camp Time :</Label>
                  <div style={{ display: "flex" }}>
                    <CustomInput
                      id="year"
                      type="radio"
                      label="Year"
                      name="campTime"
                      checked={!this.state.showDatePickerForCampDates}
                      onClick={(event) => {
                        this.setState({
                          installments: 0,
                          showDatePickerForCampDates: false,
                        });
                      }}
                    />
                    <CustomInput
                      id="months"
                      type="radio"
                      label="Months"
                      name="campTime"
                      onClick={(event) => {
                        this.setState({
                          showDatePickerForCampDates: true,
                        });
                      }}
                    />
                  </div>
                </FormGroup>
              </Col>
              {this.state.showDatePickerForCampDates ? (
                <>
                  <Col>
                    <FormGroup>
                      <Label>Start Date</Label>
                      <Input
                        id="startDate"
                        name="startDate"
                        type="date"
                        value={this.state.startDate}
                        onChange={(event) => {
                          this.setState({
                            startDate: event.target.value,
                          });
                        }}
                        placeholder="Select the date"
                        required={false}
                        min={this.state.minDate}
                        max={this.state.maxDate}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>End Date</Label>
                      <Input
                        id="endDate"
                        name="endDate"
                        type="date"
                        value={this.state.endDate}
                        onChange={(event) => {
                          this.setState({
                            endDate: event.target.value,
                          });
                        }}
                        placeholder="Select the date"
                        required={false}
                        min={this.state.minDate}
                        max={this.state.maxDate}
                      />
                    </FormGroup>
                  </Col>
                </>
              ) : null}
              <Col>
                <FormGroup>
                  <Label for="exampleCheckbox">Select Payments :</Label>
                  <div style={{ display: "flex" }}>
                    <CustomInput
                      id="yearly"
                      type="radio"
                      label="Onetime"
                      checked={!this.state.showTextBoxForInstallment}
                      name="paymentType"
                      onClick={(event) => {
                        this.setState({
                          installments: 0,
                          showTextBoxForInstallment: false,
                        });
                      }}
                    />
                    <CustomInput
                      id="monthly"
                      type="radio"
                      label="Installments"
                      name="paymentType"
                      onClick={(event) => {
                        this.setState({
                          showTextBoxForInstallment: true,
                        });
                      }}
                    />
                  </div>
                </FormGroup>
              </Col>
              {this.state.showTextBoxForInstallment ? (
                <>
                  <Col>
                    <FormGroup>
                      <Label for="installments">Select Installments</Label>
                      <CustomInput
                        type="select"
                        id="installments"
                        name="selectInstallments"
                        defaultValue={"Select the value"}
                        onChange={(event) => {
                          this.setState({
                            installments: Number(event.target.value),
                          });
                        }}
                      >
                        <option value="Select the value" disabled>
                          Select the value
                        </option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </>
              ) : null}
              <Col style={{ textAlign: "right" }}>
                <Button outline color="primary" onClick={this.addCamp}>
                  Add Camp
                </Button>
              </Col>
              <Col>
                <Label>Camps</Label>
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Price</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Installments</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.camps.length > 0 ? (
                      this.state.camps.map((camp, index) => (
                        <tr key={index}>
                          <td>{camp.name}</td>
                          <td>{camp.price}</td>
                          <td>{camp.startingAt}</td>
                          <td>{camp.endingAt}</td>
                          <td>{camp.installments}</td>
                          <td>
                            <FaMinusCircle
                              size="20px"
                              onClick={(event) => this.deleteCamp(index)}
                            ></FaMinusCircle>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No Camps
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
              <Col>
                <Button
                  outline
                  color="primary"
                  type="submit"
                  disabled={disabled}
                >
                  Submit
                </Button>
              </Col>
            </Form>
          </div>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Container>
      </div>
    );
  }
}

export default ClubPage;
